import axios from "axios";
import { API_BASE } from "../config/constants";

export const formSubmissionResource = axios.create({
  baseURL: `${API_BASE}/api/v1/contact-form`,
  headers: {
    Authorization: "ApiKey 4c121cf9-4a79-4749-bcc2-c2bf5efe9d12",
  },
});

export const verificationResource = axios.create({
  baseURL: `${API_BASE}/api/v1/mcaptcha`,
  headers: {
    Authorization: "ApiKey 4c121cf9-4a79-4749-bcc2-c2bf5efe9d12",
  },
});

export const mcaptchaSettingsResource = axios.create({
  baseURL: `${API_BASE}/api/v1/mcaptcha/settings`,
});
